import React, { useEffect, useState } from "react";

export const Cart = ({ cartItems, setCartItems }) => {
  const [price, setPrice] = useState(0);
  useEffect(() => {
    let amount = 0;
    cartItems.map((c) => (amount = c.count * c.price + amount));
    setPrice(amount);
    // removed duplicate data

const duplicateremoveddata = cartItems.reduce((index,item)=>{
  if(!index.some((dds)=> dds.id === item.id)){
    index.push(item)
  }
  return index

},[])
setCartItems(duplicateremoveddata)

  })


  const addAndremove = (gettingdata, num) => {
    const updatedCart = cartItems.map(item => {
      if (item.id === gettingdata.id) {
        // Update count of the clicked product
        const newCount = item.count + num;
        // If count becomes less than or equal to zero, remove the product
        if (newCount <= 0) {
          return null; // We'll filter out null values later
        }
        return {...item, count: newCount};
      }
      return item;
    }).filter(Boolean); // Filter out null values
 
    setCartItems(updatedCart);
  };

  const removeitems = (item) => {
    const filteredItem = cartItems.filter((x) => x.id !== item.id);
    setCartItems(filteredItem);
  };
  return (
    <div>
    <div className="desktop">
    <section className="cartback container-fluid">
        <div className="heading">
          <h1 className="display-6 p-4">CART</h1>
        </div>
        <div className="row">
          <div className="row cartlist px-5 col col-lg-6">
            {cartItems.map((homeItems, index) => (
              <div key={index}>
                <section className="border-bottom py-3 px-4 w-75 text-start">
                  <div className="maindivCart d-flex">
                    <div className="subdivCart1 d-flex">
                      <div className="imageCart">
                        <img
                          src={homeItems.img}
                          class="card-img-left"
                          alt="..."
                        />
                      </div>
                      <div className="productitemsname py-4 px-5">
                        <h5 class="card-title">{homeItems.modelName}</h5>
                        <span>{homeItems.name}</span>
                      </div>
                    </div>
                    <div className="subdivCart2 py-4">
                      <div className="priceProduct">
                        <span className="px-5 ms-2">${homeItems.price}</span>
                      </div>
                      <div className="addandlessbtn d-flex mt-3 mx-4">
                        <div className="add">
                          <button
                            className="btn border-0"
                            onClick={() => addAndremove(homeItems, 1)}
                          >
                            +
                          </button>
                        </div>
                        <div className="qty py-2 mx-3">
                          <h5> {homeItems.count}</h5>
                        </div>

                        <div className="less">
                          <button
                            className="btn border-0"
                            onClick={() => addAndremove(homeItems, -1)}
                          >
                            -
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="subdivCart3">
                      <div className="remove p-5">
                        <button
                          className="btn border-0"
                          onClick={() => removeitems(homeItems)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-x-lg"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            ))}
          </div>
          <div className="pricebox px-5 mx-auto py-5 col col-lg-6">
            <div className="cardHeading">
              <h3 className="py-2">CART TOTALS</h3>
            </div>
            <div>
              <div className="subtotal d-flex mt-3 py-3 ">
                <h5>SUBTOTAL</h5>
                <span className="px-5">${price}</span>
              </div>
              <div className="d-flex">
                <h5>SHIPPING</h5>
                <div className="px-5  pb-3">
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Free shipping
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Flat rate: $49
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Local pickup: $8
                    </label>
                  </div>
                  <span>Shipping to AL.</span>
                  <br />
                  <span>CHANGE ADDRESS</span>
                </div>
              </div>
            </div>
            <div className="subtotal d-flex py-3 mt-3 border-top w-50">
              <h5>TOTAL</h5>
              <span className="px-5 mx-4">${price}</span>
            </div>
          <div className="py-3">
          <button className="btn btn-outline-dark border-0"> 
            PROCEED TO CHECKOUT
            </button>
          </div>
          </div>
        </div>
      </section>

      <footer className="footerBack">
        <div>
          <div className="maindivfooterone row mx-auto py-5 container-fluid">
            <div className="subdivfooter1  d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-truck"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>
              </div>
              <div className="footertext">
                <h5>FAST AND FREE DELIVERY</h5>
                <p>Free delivery for all orders over $140</p>
              </div>
            </div>
            <div className="subdivfooter2 d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col ">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-headset"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
                </svg>
              </div>
              <div className="footertext">
                <h5>24/7 CUSTOMER SUPPORT</h5>
                <p>Friendly 24/7 customer support</p>
              </div>
            </div>
            <div className="subdivfooter3  d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-shield-check"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56" />
                  <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                </svg>
              </div>
              <div className="footertext">
                <h5>MONEY BACK GUARANTEE</h5>
                <p>We return money within 30 days</p>
              </div>
            </div>
          </div>
          <div className="maindivfootertwo row text-light mx-auto py-5 container-fluid">
            <div className="subdivfootertwo1 col-lg-2 col m-auto ">
              <div className="logofooter">
                <img src={require("./Image/logo.png")} alt="" />
              </div>
              <div className="footertwoText1 py-1 fw-normal">
                <p>
                  1418 River Drive, Suite 35 Cottonhall, <br /> CA 9622 United
                  States
                </p>
              </div>
              <div className="footertwoText2 py-3">
                <span>sale@uomo.com</span> <br />
                <span>+1 246-345-0695</span>
              </div>
              <div className="footertwoText3 py-3 d-flex gap-4">
                <div className="footerlogo1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </div>
                <div className="footerlogo2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-twitter-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                  </svg>
                </div>
                <div className="footerlogo3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                  </svg>
                </div>
                <div className="footerlogo4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-youtube"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                  </svg>
                </div>
                <div className="footerlogo5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-pinterest"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="subdivfootertwo2 col-lg-2 col-6 m-auto">
              <div className="footerheading py-4">
                <h3>COMPANY</h3>
              </div>
              <ul>
                <li className="py-3">About Us</li>
                <li className="py-3">Careers</li>
                <li className="py-3">Affiliates</li>
                <li className="py-3">Blog</li>
                <li className="pt-3">Contact Us</li>
              </ul>
            </div>
            <div className="subdivfootertwo3 col-lg-2 col-6 m-auto">
              <div className="footerheading py-4">
                <h3>SHOP</h3>
              </div>
              <ul>
                <li className="py-3">New Arrivals</li>
                <li className="py-3">Accessories</li>
                <li className="py-3">Men</li>
                <li className="py-3">Women</li>
                <li className="pt-3">Shop All</li>
              </ul>
            </div>
            <div className="subdivfootertwo4 col-lg-2 col-6 m-auto">
              <div className="footerheading pt-5">
                <h3>HELP</h3>
              </div>
              <ul>
                <li className="pt-4 pb-3">Customer Service</li>
                <li className="py-3">My Account</li>
                <li className="py-3">Find a Store</li>
                <li className="py-3">Legal & Privacy</li>
                <li className="py-3">Contact</li>
                <li className="pt-3">Gift Card</li>
              </ul>
            </div>
            <div className="subdivfootertwo5 col-lg-2 col-6 m-auto">
              <div className="footerheading">
                <h3>SUBSCRIBE</h3>
              </div>
              <div className="para py-3">
                <p>
                  Be the first to get the latest news about trends, promotions,
                  and much more!
                </p>
              </div>
              <div className="form">
                <input
                  type="text"
                  placeholder="Your email address"
                  className=" border-0 border-bottom btn my-3"
                />
                <button className="btn btn-outline-light border-0">JOIN</button>
              </div>
            </div>
          </div>
          <div className="copyright text-center text-light py-3">
            <span> @ 2024 design by V!</span>
          </div>
        </div>
      </footer>
    </div>

    <div className="mobliephone">
    <section className="cartback container-fluid">
        <div className="heading">
          <h1 className="display-6 p-4">CART</h1>
        </div>
        <div className="row">
          <div className="row cartlist mx-auto px-5 col col-lg-6">
            {cartItems.map((homeItems, index) => (
              <div key={index}>
                <section className="border-bottom py-3 px-4 w-75 text-start">
                  <div className="maindivCart d-flex">
                    <div className="subdivCart1 d-flex">
                      <div className="imageCart">
                        <img
                          src={homeItems.img}
                          class="card-img-left"
                          alt="..."
                        />
                      </div>
                      <div className="productitemsname py-4 px-3">
                        <h5 class="card-title">{homeItems.modelName}</h5>
                        <span>{homeItems.name}</span>
                      </div>
                    </div>
                    <div className="subdivCart2 py-3">
                      <div className="priceProduct">
                        <span className="px-5 ms-2">${homeItems.price}</span>
                      </div>
                      <div className="addandlessbtn d-flex mt-3 mx-2">
                        <div className="add">
                          <button
                            className="btn border-0"
                            onClick={() => addAndremove(homeItems, 1)}
                          >
                            +
                          </button>
                        </div>
                        <div className="qty py-2 mx-3">
                          <h5> {homeItems.count}</h5>
                        </div>

                        <div className="less">
                          <button
                            className="btn border-0"
                            onClick={() => addAndremove(homeItems, -1)}
                          >
                            -
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="subdivCart3">
                      <div className="remove py-5">
                        <button
                          className="btn border-0"
                          onClick={() => removeitems(homeItems)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-x-lg"
                            viewBox="0 0 16 16"
                          >
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            ))}
          </div>
          <div className="pricebox px-5 mx-auto py-5 col col-lg-6">
            <div className="cardHeading">
              <h3 className="py-2">CART TOTALS</h3>
            </div>
            <div>
              <div className="subtotal d-flex mt-3 py-3 ">
                <h5>SUBTOTAL</h5>
                <span className="px-5">${price}</span>
              </div>
              <div className="d-flex">
                <h5>SHIPPING</h5>
                <div className="px-5  pb-3">
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Free shipping
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Flat rate: $49
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="autoSizingCheck2"
                    />
                    <label class="form-check-label" for="autoSizingCheck2">
                      Local pickup: $8
                    </label>
                  </div>
                  <span>Shipping to AL.</span>
                  <br />
                  <span>CHANGE ADDRESS</span>
                </div>
              </div>
            </div>
            <div className="subtotal d-flex py-3 mt-3 border-top w-50">
              <h5>TOTAL</h5>
              <span className="px-5 mx-4">${price}</span>
            </div>
          <div className="py-3">
          <button className="btn btn-outline-dark border-0"> 
            PROCEED TO CHECKOUT
            </button>
          </div>
          </div>
        </div>
      </section>

      <footer className="footerBack">
        <div>
          <div className="maindivfooterone row mx-auto py-5 container-fluid">
            <div className="subdivfooter1  d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-truck"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>
              </div>
              <div className="footertext">
                <h5>FAST AND FREE DELIVERY</h5>
                <p>Free delivery for all orders over $140</p>
              </div>
            </div>
            <div className="subdivfooter2 d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col ">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-headset"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5" />
                </svg>
              </div>
              <div className="footertext">
                <h5>24/7 CUSTOMER SUPPORT</h5>
                <p>Friendly 24/7 customer support</p>
              </div>
            </div>
            <div className="subdivfooter3  d-flex justify-content-evenly fw-small text-light px-5 col-lg-4 col">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="currentColor"
                  class="bi bi-shield-check"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56" />
                  <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                </svg>
              </div>
              <div className="footertext">
                <h5>MONEY BACK GUARANTEE</h5>
                <p>We return money within 30 days</p>
              </div>
            </div>
          </div>
          <div className="maindivfootertwo row text-light mx-auto py-5 container-fluid">
            <div className="subdivfootertwo1 col-lg-2 col m-auto ">
              <div className="logofooter">
                <img src={require("./Image/logo.png")} alt="" />
              </div>
              <div className="footertwoText1 py-1 fw-normal">
                <p>
                  1418 River Drive, Suite 35 Cottonhall, <br /> CA 9622 United
                  States
                </p>
              </div>
              <div className="footertwoText2 py-3">
                <span>sale@uomo.com</span> <br />
                <span>+1 246-345-0695</span>
              </div>
              <div className="footertwoText3 py-3 d-flex gap-4">
                <div className="footerlogo1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </div>
                <div className="footerlogo2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-twitter-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                  </svg>
                </div>
                <div className="footerlogo3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                  </svg>
                </div>
                <div className="footerlogo4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-youtube"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                  </svg>
                </div>
                <div className="footerlogo5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-pinterest"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="subdivfootertwo2 col-lg-2 col-6 m-auto">
              <div className="footerheading py-4">
                <h3>COMPANY</h3>
              </div>
              <ul>
                <li className="py-3">About Us</li>
                <li className="py-3">Careers</li>
                <li className="py-3">Affiliates</li>
                <li className="py-3">Blog</li>
                <li className="pt-3">Contact Us</li>
              </ul>
            </div>
            <div className="subdivfootertwo3 col-lg-2 col-6 m-auto">
              <div className="footerheading py-4">
                <h3>SHOP</h3>
              </div>
              <ul>
                <li className="py-3">New Arrivals</li>
                <li className="py-3">Accessories</li>
                <li className="py-3">Men</li>
                <li className="py-3">Women</li>
                <li className="pt-3">Shop All</li>
              </ul>
            </div>
            <div className="subdivfootertwo4 col-lg-2 col-6 m-auto">
              <div className="footerheading pt-5">
                <h3>HELP</h3>
              </div>
              <ul>
                <li className="pt-4 pb-3">Customer Service</li>
                <li className="py-3">My Account</li>
                <li className="py-3">Find a Store</li>
                <li className="py-3">Legal & Privacy</li>
                <li className="py-3">Contact</li>
                <li className="pt-3">Gift Card</li>
              </ul>
            </div>
            <div className="subdivfootertwo5 col-lg-2 col-6 m-auto">
              <div className="footerheading">
                <h3>SUBSCRIBE</h3>
              </div>
              <div className="para py-3">
                <p>
                  Be the first to get the latest news about trends, promotions,
                  and much more!
                </p>
              </div>
              <div className="form">
                <input
                  type="text"
                  placeholder="Your email address"
                  className=" border-0 border-bottom btn my-3"
                />
                <button className="btn btn-outline-light border-0">JOIN</button>
              </div>
            </div>
          </div>
          <div className="copyright text-center text-light py-3">
            <span> @ 2024 design by V!</span>
          </div>
        </div>
      </footer>
    </div>
    </div>
  );
};
